import React from 'react';
import Select, { components, OptionProps, OptionTypeBase } from 'react-select';
import { useCDK } from 'lib/hooks/useCdk';
import { Flex } from 'lib/components/styles/layout';

const CustomSingleValue = (props: any) => {
  const { data } = props;
  const { getLogoByActiveState } = useCDK();
  const { src, alt } = getLogoByActiveState();
  return (
    <components.SingleValue {...props}>
      {data.sharedWithAll ? (
        <Flex flexDirection='row' alignItems='center' gap='8px'>
          <img src={src} alt={alt} width={14} height={14} />
          {data.title}
        </Flex>
      ) : (
        <>{data.title}</>
      )}
    </components.SingleValue>
  );
};

const CustomOption = (props: OptionProps<OptionTypeBase, boolean>) => {
  const { data, innerRef, innerProps } = props;
  const { getLogoByActiveState } = useCDK();
  const { src, alt } = getLogoByActiveState();
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: '10px 15px',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 500,
        color: '#001B53',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}
    >
      {data.sharedWithAll ? (
        <Flex flexDirection='row' alignItems='center' gap='8px'>
          <img src={src} alt={alt} width={14} height={14} />
          {data.title}
        </Flex>
      ) : (
        data.title
      )}
    </div>
  );
};

interface ScriptSelectorProps {
  options: any[];
  value: any;
  onChange: (selectedOption: any) => void;
  isLoading: boolean;
  onMenuClose?: () => void;
}

export const ScriptSelector = ({
  options,
  value,
  onChange,
  isLoading,
  onMenuClose,
}: ScriptSelectorProps) => {
  return (
    <Flex
      width='100%'
      justifyContent='space-between'
      alignItems='baseline'
      gap='16px'
      margin='16px 0'
    >
      <Select
        components={{
          SingleValue: CustomSingleValue,
          Option: CustomOption,
        }}
        styles={{
          control: (base: any) => ({
            ...base,
            height: '40px',
            cursor: 'pointer',
          }),
          container: (base: any) => ({ ...base, width: '100%' }),
          option: (base: any) => ({
            ...base,
            cursor: 'pointer',
          }),
          menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
          indicatorSeparator: () => ({ display: 'none' }),
        }}
        options={options}
        menuPortalTarget={document.body}
        menuPosition='fixed'
        menuPlacement={'bottom'}
        placeholder='Select a script'
        value={value}
        onChange={onChange}
        getOptionLabel={(option: any) => option.title}
        getOptionValue={(option: any) => option.scriptId}
        isLoading={isLoading}
        onMenuClose={onMenuClose}
        isDisabled={isLoading}
      />
    </Flex>
  );
};
